import { IAction } from "../../../interface/action.interface";
import { IUserDetailsDto } from "../interface/dto/user-details.dto";

export enum AuthActionType {
    AUTH_INIT = "AUTH_INIT",
    AUTH_REDIRECT = "AUTH_REDIRECT",
    AUTH_LOGIN = "AUTH_LOGIN",
    AUTH_REQUEST_ACCESS = "AUTH_REQUEST_ACCESS",
    AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS",
    AUTH_LOGIN_ERROR = "AUTH_LOGIN_ERROR",
    USER_DETAILS_GET = "USER_DETAILS_GET",
    USER_DETAILS_GET_SUCCESS = "USER_DETAILS_GET_SUCCESS",
    USER_DETAILS_GET_ERROR = "USER_DETAILS_GET_ERROR",
}

export interface IAuthInitAction extends IAction {
    type: AuthActionType.AUTH_INIT;
    payload: undefined;
}

export interface IAuthRedirectAction extends IAction {
    type: AuthActionType.AUTH_REDIRECT;
    payload: undefined;
}

export interface IAuthLoginAction extends IAction {
    type: AuthActionType.AUTH_LOGIN;
    payload: {
        code: string;
    };
}

export interface IAuthRequestAccessAction extends IAction {
    type: AuthActionType.AUTH_REQUEST_ACCESS;
    payload: undefined;
}

export interface IAuthLoginSuccessAction extends IAction {
    type: AuthActionType.AUTH_LOGIN_SUCCESS;
    payload: {
        accessToken: string;
        refreshToken: string;
    };
}

export interface IAuthLoginErrorAction extends IAction {
    type: AuthActionType.AUTH_LOGIN_ERROR;
    payload: {
        error: string;
    };
}

export interface IUserDetailsGetAction extends IAction {
    type: AuthActionType.USER_DETAILS_GET;
}

export interface IUserDetailsGetSuccessAction extends IAction {
    type: AuthActionType.USER_DETAILS_GET_SUCCESS;
    payload: IUserDetailsDto;
}

export interface IUserDetailsGetErrorAction extends IAction {
    type: AuthActionType.USER_DETAILS_GET_ERROR;
    payload: {
        error: string;
    };
}

export const authInit = (): IAuthInitAction => ({
    type: AuthActionType.AUTH_INIT,
    payload: undefined,
});

export const authRedirect = (): IAuthRedirectAction => ({
    type: AuthActionType.AUTH_REDIRECT,
    payload: undefined,
});

export const authLogin = (code: string): IAuthLoginAction => ({
    type: AuthActionType.AUTH_LOGIN,
    payload: {
        code,
    },
});

export const authRequestAccess = (): IAuthRequestAccessAction => ({
    type: AuthActionType.AUTH_REQUEST_ACCESS,
    payload: undefined,
});

export const authLoginSuccess = (
    accessToken: string,
    refreshToken: string,
): IAuthLoginSuccessAction => ({
    type: AuthActionType.AUTH_LOGIN_SUCCESS,
    payload: {
        accessToken,
        refreshToken,
    },
});

export const authLoginError = (error: string): IAuthLoginErrorAction => ({
    type: AuthActionType.AUTH_LOGIN_ERROR,
    payload: {
        error,
    },
});

export const userDetailsGetAction = (): IUserDetailsGetAction => ({
    type: AuthActionType.USER_DETAILS_GET,
    payload: {},
});

export const userDetailsGetSuccessAction = (
    userDetails: IUserDetailsDto,
): IUserDetailsGetSuccessAction => ({
    type: AuthActionType.USER_DETAILS_GET_SUCCESS,
    payload: userDetails,
});

export const userDetailsGetErrorAction = (error: string) => ({
    type: AuthActionType.USER_DETAILS_GET_ERROR,
    payload: { error },
});

export type IAuthAction =
    | IAuthInitAction
    | IAuthLoginAction
    | IAuthLoginSuccessAction
    | IAuthLoginErrorAction
    | IUserDetailsGetAction
    | IUserDetailsGetSuccessAction
    | IUserDetailsGetErrorAction;
